import { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
}

/**
 * Drop-in replacement for <input type="password"> that adds a
 * show/hide toggle button inside the input field.
 */
export default function PasswordInput({ className = 'input', ...props }: PasswordInputProps) {
  const [visible, setVisible] = useState(false)

  return (
    <div className="relative">
      <input
        {...props}
        type={visible ? 'text' : 'password'}
        className={className}
        style={{ paddingRight: '2.5rem', ...props.style }}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        className="absolute inset-y-0 right-0 flex items-center px-3 focus:outline-none"
        style={{ color: 'var(--text-tertiary)' }}
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        {visible
          ? <EyeOff className="h-4 w-4" />
          : <Eye    className="h-4 w-4" />
        }
      </button>
    </div>
  )
}
